import qs from 'qs';
import ApiResourceManager from '../ApiResourceManager';

export default class MenusManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/menus',
      params,
      paramsSerializer: qs.stringify,
    });

  show = (id) =>
    this.request({
      method: 'GET',
      url: `/menus/${id}`,
    });

  create = (data) =>
    this.request({
      method: 'POST',
      url: '/menus',
      data,
    });

  update = (id, data) =>
    this.request({
      method: 'PUT',
      url: `/menus/${id}`,
      data,
    });

  delete = (id) =>
    this.request({
      method: 'DELETE',
      url: `/menus/${id}`,
    });

  import = (data) =>
    this.request({
      method: 'POST',
      url: '/menu/import',
      data,
    });

  /**
   * The acting subject's most recent menu import run (`data: null` when it
   * never imported): `status` pending | running | succeeded | failed, plus a
   * translated `error_message` and the scraper's raw `error_detail`. A run the
   * scraper refused because it paused the link has `error_code: listing_blocked`
   * with `block_reason` and `blocked_until`.
   */
  latestImport = (params) =>
    this.request({
      method: 'GET',
      url: '/menu/imports/latest',
      params,
    });

  /**
   * Super admins only: lifts the scraper's pause on a failed import's link, so
   * the next import calls the platform again.
   */
  releaseImportBlock = (uuid) =>
    this.request({
      method: 'DELETE',
      url: `/menu/imports/${uuid}/block`,
    });

  /**
   * The tax categories assignable to a product/category in the current menu
   * context (company, or master/franchise) - the partner's set merged with
   * the acting company's own overrides. Sits under ReadMenu, not the
   * stricter tax-categories permission.
   */
  taxCategories = (params) =>
    this.request({
      method: 'GET',
      url: '/menu/tax-categories',
      params,
    });

  toggleVisible = (menu) =>
    this.update(menu.id, {
      ...menu,
      is_visible: !menu.is_visible,
    });
}
